import { usePrevious } from '@flippingbook/web.react-hooks/dist/usePrevious';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { driftService } from '@/services/instance/drift';

export function DriftPageHelper() {
    const location = useLocation();
    const prevLocation = usePrevious(location);

    useEffect(() => {
        if (prevLocation) {
            driftService.page();
        }
    }, [location, prevLocation]);

    return null;
}
